module.exports = {
    field: 'form-group field-name ',
    label: "col-sm-2 control-label",
    error: 'error-block help-block',
    help: 'help-block',
    hasError: 'has-error',
    hasTitle: "col-sm-10",
    noTitle: "col-sm-12"
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/EditorTemplate-style.js
 **/